import { Box, Chip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const PARTS = {
  A1: "A1.1 + A1.2 + A1.3",
  A2: "A2.1 + A2.2 + A2.3",
  B1: "B1.1 + B1.2 + B1.3",
  B2: "B2.1 + B2.2 + B2.3",
  C1: "C1.1 + C1.2 + C1.3",
};

const LABELS = { en: "Complete", de: "Komplett", ar: "كامل" };

const CourseLevelCoverage = ({ level, compact = false }) => {
  const { i18n } = useTranslation();
  const baseLevel = String(level || "").toUpperCase().match(/^(A1|A2|B1|B2|C1)/)?.[1];
  if (!baseLevel) return null;
  const language = i18n.language?.startsWith("ar") ? "ar" : i18n.language?.startsWith("de") ? "de" : "en";

  return (
    <Box sx={{ display: "inline-flex", alignItems: "center", flexWrap: "wrap", gap: compact ? 0.75 : 1 }}>
      <Chip size={compact ? "small" : "medium"} label={LABELS[language]} sx={{ bgcolor: "#fff", color: "#111", fontWeight: 900 }} />
      <Typography component="span" fontWeight={800} sx={{ fontSize: compact ? "0.78rem" : { xs: "0.9rem", md: "1rem" }, direction: "ltr" }}>
        ({PARTS[baseLevel]})
      </Typography>
    </Box>
  );
};

export default CourseLevelCoverage;
